// extracted by mini-css-extract-plugin
export default {"block":"j4A2kBhEZFApLggU3PfQ"};